import { createContext } from 'react';

const EventDetailsContext = createContext();

export default EventDetailsContext;
